import { Link } from "react-router-dom";
import { homepageSections } from "@/mocks/comics";
import { getComicById } from "@/mocks/comics";

export default function RecommendedSection() {
  const recIds = homepageSections.recommended;
  const recComics = recIds.map((id) => getComicById(id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            编辑精选
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            全部精选 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {recComics.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              >
                <div className="w-24 h-32 md:w-28 md:h-40 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col justify-between min-w-0 flex-1">
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-2">{comic.author} · {comic.status}</p>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                      {comic.description}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 flex-wrap mt-2">
                    {comic.tags.slice(0, 3).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                    <span className="text-xs text-foreground-400">
                      {comic.views >= 10000
                        ? `${(comic.views / 10000).toFixed(1)}万阅读`
                        : `${comic.views}阅读`}
                    </span>
                  </div>
                </div>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}